export default __webpack_public_path__ + "static/media/screen1.e14da076.png";